require("./ynet_site_mediaOverlayDisplay.less");
import { VerticalVideoOverlayPlayer } from "../verticalVideoOverlayPlayer/verticalVideoOverlayPlayer";
import { categoryObj } from "../ynet1280/newYnetTvVerticalDynamic/components/newYnetTvVerticalDynamicComponenta";
import { SiteItemData } from "../../interfaces";
import { ImageDetails } from "../../../images/interfaces";
import { ImageOverlayDisplay } from "./imageOverlayDisplay";
import { GenericLightboxVideoPlayer } from "../../siteWidgets/videoPlayer/genericLightboxVideoPlayer/genericLightboxVideoPlayer";

interface MediaOverlayDisplayProps {
    mediaType?: string
    index?: number; //used in gallery view
    domain?: string;
    isLTR?: boolean;
    category?: categoryObj
    isMobile?: boolean;
    articleId?: string;
    videoItems?: SiteItemData | SiteItemData[];
    imageDetails?: ImageDetails;
    languageCode?: string;
    isOverlayOpen?: boolean;
    showPrerollAds?: boolean;
    isTitleVisible?: boolean;
    isSubTitleVisible?: boolean;
    selectedVideoIndex?: number; //used in gallery view
    isSingleVideoDisplay?: boolean;
    onMediaOverlayClose?: (e?: React.MouseEvent) => void;
}

export const MediaOverlayDisplay = (props: MediaOverlayDisplayProps) => {

    const { domain, isLTR, imageDetails, category, isMobile, mediaType, videoItems, languageCode, isOverlayOpen, showPrerollAds, isTitleVisible, isSubTitleVisible,
        isSingleVideoDisplay, articleId, onMediaOverlayClose } = props;

    if (!isOverlayOpen) return null;

    if (mediaType === "image") {
        return (
            <div className="media-overlay-display">
                <ImageOverlayDisplay
                    imageDetails={imageDetails}
                    isOverlayOpen={isOverlayOpen}
                    onMediaOverlayClose={onMediaOverlayClose}
                />
            </div>
        );
    } else if (mediaType === "video") {
        return (
            <div className="media-overlay-display">
                {isMobile ?
                    <VerticalVideoOverlayPlayer
                        isLTR={isLTR}
                        domain={domain}
                        isMobile={isMobile}
                        category={category}
                        videoItems={videoItems}
                        languageCode={languageCode}
                        isOverlayOpen={isOverlayOpen}
                        showPrerollAds={showPrerollAds}
                        isTitleVisible={isTitleVisible}
                        isSubTitleVisible={isSubTitleVisible}
                        onVideoOverlayClose={onMediaOverlayClose}
                        isSingleVideoDisplay={isSingleVideoDisplay}
                    />
                    :
                    <div className="video-overlay-display">
                        <div className="close-btn" onClick={onMediaOverlayClose}></div>

                        <GenericLightboxVideoPlayer
                            width={640}
                            height={640 * (9 / 16)}
                            applyStickyness={false}
                            hideVideoAds={showPrerollAds}
                            data={(videoItems as SiteItemData).media as any}
                        />
                    </div>
                }
            </div>
        )
    }
}

MediaOverlayDisplay.siteScriptName = "MediaOverlayDisplay";